import { render, staticRenderFns } from "./Vuetify.vue?vue&type=template&id=5b1be35e"
import script from "./Vuetify.vue?vue&type=script&lang=js"
export * from "./Vuetify.vue?vue&type=script&lang=js"
import style0 from "./Vuetify.vue?vue&type=style&index=0&id=5b1be35e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1be35e')) {
      api.createRecord('5b1be35e', component.options)
    } else {
      api.reload('5b1be35e', component.options)
    }
    module.hot.accept("./Vuetify.vue?vue&type=template&id=5b1be35e", function () {
      api.rerender('5b1be35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/vuetify/Vuetify.vue"
export default component.exports